module.exports = __webpack_public_path__ + "img/home_my_value_04.9ef59068.png";